import * as React from 'react'

import { useAuthStateCtx } from '~logic/auth/AuthProvider'
import { EmailInput, NameInput, PhoneInput } from '~shared/segments/Form'
import { InputGroup } from '~ui/components/formElements/accessories/InputGroup'

import { useCustomerAccountsEnabledCtx } from '../../CustomerAccounts'
import { RememberForm } from './RememberForm'

type TRememberFormProps = PropsOf<typeof RememberForm>

type TProps = TRememberFormProps & {
  /**
   * email verification message to be displayed
   * used when the user has an account and his email is not verified
   */
  emailVerificationMessage?: React.ReactNode
}

/**
 * Groups together basic customer information inputs.
 */
export const ContactInputGroup: React.FC<TProps> = ({
  emailVerificationMessage,
  ...rememberFormProps
}) => {
  const { isLoggedIn } = useAuthStateCtx()
  const { areCustomerAccountsEnabled } = useCustomerAccountsEnabledCtx()

  const isDisabled = isLoggedIn && areCustomerAccountsEnabled

  return (
    <InputGroup>
      <NameInput isRequired />
      <PhoneInput isDisabled={isDisabled} />
      <EmailInput isDisabled={isDisabled} />

      {emailVerificationMessage}

      {!isLoggedIn && <RememberForm {...rememberFormProps} />}
    </InputGroup>
  )
}
